import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Debt } from '../../types';
import * as debtsApi from '../../services/api/debtsApi';

interface DebtsState {
  debts: Debt[];
  loading: boolean;
  error: string | null;
  selectedDebt: Debt | null;
}

const initialState: DebtsState = {
  debts: [],
  loading: false,
  error: null,
  selectedDebt: null,
};

// Async thunks
export const fetchDebts = createAsyncThunk(
  'debts/fetchDebts',
  async (_, { rejectWithValue }) => {
    try {
      return await debtsApi.getDebts();
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch debts');
    }
  }
);

export const uploadMonthlyUpdate = createAsyncThunk(
  'debts/uploadMonthlyUpdate',
  async (file: File, { rejectWithValue }) => {
    try {
      await debtsApi.uploadMonthlyUpdate(file);
      return true;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to upload monthly update');
    }
  }
);

const debtsSlice = createSlice({
  name: 'debts',
  initialState,
  reducers: {
    setSelectedDebt: (state, action: PayloadAction<Debt | null>) => {
      state.selectedDebt = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch debts
    builder
      .addCase(fetchDebts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDebts.fulfilled, (state, action) => {
        state.loading = false;
        state.debts = action.payload;
      })
      .addCase(fetchDebts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Upload monthly update
    builder
      .addCase(uploadMonthlyUpdate.fulfilled, (state) => {
        // Optionally refresh debts list after upload
      });
  },
});

export const { setSelectedDebt, clearError } = debtsSlice.actions;
export default debtsSlice.reducer;

